import {Injectable} from '@angular/core';
import * as moment from 'moment-timezone';
import {Moment} from 'moment-timezone';

// Creates moment instance in NY timezone

@Injectable()
export class NyTzMoment {

	constructor() {

	}

	public create(value?: any, format?: string): Moment {
		if (format) {
			return moment.tz(value, format, 'America/New_York');
		} else {
			return moment.tz(value, 'America/New_York');
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/ny-tz-moment.service.ts